var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.animateRocket)?_c('div',{staticClass:"rocket-container launch"},[_c('img',{staticClass:"rocket",attrs:{"src":_vm.rocket,"alt":"rocket"}})]):_c('div',{staticClass:"rocket-container"})
}
var staticRenderFns = []

export { render, staticRenderFns }